var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "17",
        viewBox: "0 0 16 17",
        fill: "none",
      },
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_2784_3405)" } }, [
        _c("path", {
          attrs: {
            d: "M8.53041 -1.05713C9.20289 -1.05713 9.74619 -0.513829 9.74619 0.158648V1.515C9.80698 1.5226 9.86397 1.5302 9.92476 1.54159C9.93995 1.54539 9.95135 1.54539 9.96655 1.54919L11.7902 1.88353C12.4513 2.00511 12.8882 2.63959 12.7666 3.29687C12.6451 3.95415 12.0106 4.39487 11.3533 4.27329L9.54863 3.94275C8.35944 3.76798 7.31084 3.88576 6.57377 4.17831C5.83671 4.47085 5.54036 4.87358 5.47198 5.24591C5.39599 5.65244 5.45298 5.8804 5.51757 6.02097C5.58595 6.16914 5.72653 6.33631 6.00388 6.52248C6.62316 6.929 7.57299 7.19495 8.80396 7.52169L8.91414 7.55209C10.0007 7.84084 11.3305 8.19037 12.3183 8.83625C12.8578 9.18959 13.3669 9.6683 13.6823 10.337C14.0052 11.0171 14.0736 11.7769 13.9254 12.5862C13.6633 14.0299 12.6679 14.9949 11.4331 15.5002C10.9126 15.713 10.3465 15.8498 9.74619 15.9181V17.1795C9.74619 17.852 9.20289 18.3953 8.53041 18.3953C7.85794 18.3953 7.31464 17.852 7.31464 17.1795V15.8536C7.29944 15.8498 7.28044 15.8498 7.26525 15.846H7.25765C6.33062 15.7016 4.8071 15.3027 3.78129 14.8467C3.1696 14.5732 2.89225 13.8551 3.1658 13.2434C3.43935 12.6318 4.15742 12.3544 4.7691 12.628C5.56316 12.9813 6.87012 13.3308 7.62618 13.4486C8.83816 13.6272 9.83737 13.5246 10.5136 13.2472C11.1557 12.9851 11.4483 12.6052 11.5319 12.1492C11.604 11.7465 11.5471 11.5148 11.4825 11.3742C11.4103 11.2222 11.2697 11.055 10.9886 10.8689C10.3655 10.4624 9.41185 10.1964 8.17708 9.86966L8.0707 9.84307C6.9879 9.55432 5.65814 9.20098 4.67032 8.5551C4.13082 8.20177 3.62551 7.71926 3.31017 7.05058C2.99103 6.3705 2.92644 5.61064 3.07842 4.80139C3.35197 3.35006 4.43857 2.40783 5.67334 1.91772C6.17865 1.71636 6.73334 1.57959 7.31464 1.4998V0.158648C7.31464 -0.513829 7.85794 -1.05713 8.53041 -1.05713Z",
            fill: "#010A11",
          },
        }),
      ]),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_2784_3405" } }, [
          _c("rect", {
            attrs: {
              width: "16",
              height: "16",
              fill: "white",
              transform: "translate(0 0.942871)",
            },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }